/**
 * @generated SignedSource<<12de7868e358f4debfdb863ae2025402>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PostCardFeedDashboardBlockFragment$data = {
  readonly dashboard: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
  };
  readonly showCover: boolean;
  readonly " $fragmentType": "PostCardFeedDashboardBlockFragment";
};
export type PostCardFeedDashboardBlockFragment$key = {
  readonly " $data"?: PostCardFeedDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PostCardFeedDashboardBlockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PostCardFeedDashboardBlockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showCover",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "dashboard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "usePermissionsFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FeedDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "6a2552bd18dc70ed1f000b5144aaf8bb";

export default node;
